<template>
    <div name="card-info">
        <loading v-if="isLoading" />
        <steps :step=2 />
        <div class="contain">
            <div>
                <text-label 
                    :text="'카드 번호'"
                    :isDefault="true"
                />
                <div class="card-input" ref="cardInput">
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber1" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber2')" @keydown="moveToPrev($event, null)" ref="cardNumber1"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber2" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber3')" @keydown="moveToPrev($event, 'cardNumber1')" ref="cardNumber2"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber3" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber4')" @keydown="moveToPrev($event, 'cardNumber2')" ref="cardNumber3"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber4" placeholder="0000" inputmode="numeric" @keydown="moveToPrev($event, 'cardNumber3')" ref="cardNumber4">
                </div>
            </div>
            <div class="direction-row" style="margin-top: 20px;">
                <div style="width:calc(50% - 4px)">
                    <text-label 
                        :text="'유효기간'"
                        :isDefault="true"
                    />
                    <input 
                        v-model="card_ex"
                        inputmode="numeric"
                        v-focus-background
                        placeholder="MMYY"
                        maxlength="4"
                        class="input-big"
                         style="width: calc(100% - 32px)"
                        ref="cardEx"
                    />
                </div>
                <div  style="width:calc(50% - 4px)">   
                    <text-label 
                        :text="'비밀번호 앞 2자리'"
                        :isDefault="true"
                        style="font-size: 0px;"
                    />
                    <input
                        type="password"
                        inputmode="numeric"
                        maxlength="2"
                        class="input-big"
                        v-focus-background
                        placeholder="**"
                        v-model="card_pw"
                        style="width: calc(100% - 32px)"
                        ref="cardPw"
                    />
                </div>
            </div>
            <div style="margin-top: 20px;">
                <text-label 
                    :text="'이름 (카드 소유자)'"
                    :isDefault="true"
                />
                <input 
                    type="text"
                    v-model="card_info.card_user_name"
                    class="input-big"
                    v-focus-background
                    placeholder="이름을 적어주세요"
                    ref="name"
                />
            </div>
            <div style="margin-top: 20px;margin-bottom: 40px;">
                <text-label 
                    :text="'생년월일'"
                    :isDefault="true"
                />
                <input 
                    type="text"
                    inputmode="numeric"
                    maxlength="6"
                    v-model="birth"
                    class="input-big"
                    v-focus-background
                    placeholder="990101"
                    ref="birth"
                />
            </div>
            <div class="button-wrapper">
                <bottom-button 
                    :text="'제출하기'"
                    :color="'#184FA1'"
                    @onClick="nextStep"
                />
            </div>

        </div>
        
    </div>
</template>

<script>
import Steps from '@/components/molecules/sleepq/Steps';
import BottomButton from '@/components/atoms/BottomButton';
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import focusBackground from '@/components/directives/focusBackground';
import focusInputCard from '@/components/directives/focusInputCard';
import Convert from '@/utilities/convert';
import Constant from '@/constant';
import axios from 'axios';
import Loading from '@/components/molecules/Loading'

export default {
    name: 'cardInfo',
    computed: mapState(['card_info']),
    components: {
        Steps,
        BottomButton,
        TextLabel,
        Loading
    },
    directives: {
        focusBackground,
        focusInputCard
    },
    mounted: function()
    {
        this.topFunction();
    }, 
    data: function()
    {
        return {
            cardNumber1: '',
            cardNumber2: '',
            cardNumber3: '',
            cardNumber4: '',
            card_ex: '',
            card_pw: '',
            birth: '',
            isLoading: false
        }
    },
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        handleFocus: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
            this.$refs['cardInput'].style.border = "1px solid #184FA1"
        },
        handleFocusOut: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            this.$refs['cardInput'].style.border = "#f5f7fa"
        },
        nextStep: function()
        {
            // 카드번호 각 자리별 자리수 확인, 숫자 확인
            // 유효기간
            if(this.cardNumber1.length != 4)
            {
                this.errorFocus('cardNumber1');
                return;
            }
            if(this.cardNumber2.length != 4)
            {
                this.errorFocus('cardNumber2');
                return;
            }
            if(this.cardNumber3.length != 4)
            {
                this.errorFocus('cardNumber3');
                return;
            }
            if(this.cardNumber4.length != 4)
            {
                this.errorFocus('cardNumber4');
                return;
            }

            this.card_info.card_number = this.cardNumber1 + this.cardNumber2 + this.cardNumber3 + this.cardNumber4;

            if(this.card_ex.length === 4)
            {
                this.card_info.card_ex_month = this.card_ex.substring(0, 2);
                this.card_info.card_ex_year = this.card_ex.substring(2, 4);
            }
            else 
            {
                this.errorFocus('cardEx');
                return;
            }

            if(this.card_pw.length !== 2)
            {
                this.errorFocus('cardPw');
                return;
            }
            if(this.card_info.card_user_name == '' || Convert.containsNumber(this.card_info.card_user_name))
            {
                this.errorFocus('name');
                return;
            }

            if(this.birth.length !== 6)
            {
                this.errorFocus('birth')
                return;
            }

            if(!Convert.isValidBirthdate(this.birth))
            {
                this.errorFocus('birth')
                return;
            }

            // this.card_info.card_ex = this.card_ex;
            this.card_info.card_pw = this.card_pw;
            this.card_info.card_nick_name = this.card_info.card_user_name;
            this.card_info.card_user_birth = this.birth;
            this.isLoading = true;
            this.$store.dispatch(Constant.REGISTER_BAROCARE_USER)
                .then(() => {
                    // api call, card error 
                    this.isLoading = false;
                    this.$emit('nextStep', 2)
                    
                    // send alimtalk 
                })
                .catch((error) => {
                    if(error.code.includes('PAYMENT'))
                    {
                        this.isLoading = false;
                        this.$emit('onCardError', error.message);
                    }
                    else
                    {
                        this.isLoading = false;
                        this.$emit('onError', error.message);
                    }
                    
                })
        },
        moveToNext: function(event, nextField) {
            if (event.target.value.length === 4) {
                this.$refs[nextField].focus();
            }
        },
        moveToPrev: function(event, prevField) {
            if (event.key === 'Backspace' && event.target.value.length === 0 && prevField) {
                this.$refs[prevField].focus();
            }
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        }
    },
    watch: {
        cardNumber1: function(newValue)
        {
            this.cardNumber1 = newValue.replace(/[^0-9]/g, '');
            if(this.cardNumber1.length === 4 || this.cardNumber1.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber2: function(newValue)
        {
            this.cardNumber2 = newValue.replace(/[^0-9]/g, '');
            if(this.cardNumber2.length === 4 || this.cardNumber2.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber3: function(newValue)
        {
            this.cardNumber3 = newValue.replace(/[^0-9]/g, '');
            if(this.cardNumber3.length === 4)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber4: function(newValue)
        {
            this.cardNumber4 = newValue.replace(/[^0-9]/g, '');
            if(this.cardNumber4.length === 4)
            {
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        card_ex: function(newValue)
        {
            this.card_ex = newValue.replace(/[^0-9]/g, '');
        },
        card_pw: function(newValue)
        {
            this.card_pw = newValue.replace(/[^0-9]/g, '');
        },
        birth: function(newValue)
        {
            this.birth = newValue.replace(/[^0-9]/g, '');
        }
    }
}
</script>

<style scoped>
    .card-input {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        background-color: #f5f7fa;
        width: calc(100% - 32px);
    }

    .contain {
        width: 100%;
        padding: 40px 16px 0 16px;
        display: flex;
        flex-direction: column;
    }

    .input-small {
        width: calc(25%);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 0);
        border: 0;
        outline: none;
        text-align: center;
    }
    .input-big {
        width: calc(100% - 64px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }

    .input-medium {
        width: calc(50% - 32px - 50px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
    }
    .direction-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 32px);
    }
    .button-wrapper {
        width: calc(100% - 32px);
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/sleepq/CardInfo.vue